import { createReducer, on } from '@ngrx/store';
import { reset, set, update } from './member.actions';
import { IEBMember } from '@shared/models/entities/member.interface';

export interface StateMemberType {
  data: IEBMember | null;
}

export const initialState: StateMemberType = {
  data: null,
};

export const memberReducer = createReducer(
  initialState,
  on(set, (state, { member }) => ({
    ...state,
    data: member,
  })),
  on(update, (state, { member }) => ({
    ...state,
    data: member,
  })),
  on(reset, (_) => initialState),
);
